export default __webpack_public_path__ + "static/media/Partnership-rafiki.6bab767d.png";